import type { LectureSource } from "../../constants/GlobalTypesAndEnumsAndConstants";

// Explicit projection: processing results can contain text and storage details.
// This diagnostic origin never grants access to the recording or its source.
export function lectureSourceMetadata(value: unknown): { lecture_source?: LectureSource; is_from_live_recording?: true } {
  if (!value || typeof value !== "object") return {};
  const source = value as Record<string, unknown>;
  const isIdentifier = (id: unknown): id is string => typeof id === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(id);
  const recordingId = source.recording_id;
  const uploadTaskId = source.upload_task_id;
  const hasSupportedSchema = source.schema_version === 1;
  const hasValidSourceIdentifiers = isIdentifier(recordingId) && isIdentifier(uploadTaskId);
  // Only a complete, supported source tuple can mark an upload as a lecture.
  if (!hasSupportedSchema || !hasValidSourceIdentifiers) return {};
  return {
    is_from_live_recording: true,
    lecture_source: { schema_version: 1, recording_id: recordingId, upload_task_id: uploadTaskId },
  };
}
